// Палитра и размеры взяты из студенческого приложения (educon-online-client-clt,
// src/assets/styles/global.css), чтобы кабинет ментора не расходился с ним визуально
export const ui = {
    card: '#FFFFFF',
    border: '#F0E8EE',
    ink: '#17141A',
    sub: '#6E6875',
    muted: '#9A929F',
    pink: '#C2338D',
    pinkSoft: '#FBE9F4',
    track: '#F3EBF1',
    green: '#2FA36B',
    radius: '12px',
}

export const tableStyles = {
    container: {
        border: `1px solid ${ui.border}`,
        borderRadius: '16px',
        overflow: 'hidden',
    },
    head: {
        '& .MuiTableCell-root': {
            backgroundColor: '#FCFAFC',
            borderBottom: `1px solid ${ui.border}`,
            color: ui.sub,
            fontSize: '13px',
            fontWeight: 600,
            letterSpacing: '0.02em',
            textTransform: 'uppercase',
        },
    },
    row: {
        '& .MuiTableCell-root': {
            borderBottom: `1px solid ${ui.border}`,
            color: ui.ink,
            fontSize: '14px',
        },
        '&:hover': {
            backgroundColor: '#FCFAFC',
        },
    },
}
